import Accordion from '@jetshop/ui/Accordion/Accordion';
import React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { BooleanFilters } from './BooleanFilters';
import { ListAccordion } from './Mobile/ListAccordion';
import { RangeAccordion } from './Mobile/RangeAccordion';
import { useFilters } from '@jetshop/core/hooks/Filters/useFilters';
import t from '@jetshop/intl';
import { SortOrderAccordion } from './Mobile/SortOrderAccordion';
import { theme } from '../../Theme';

const Wrapper = styled('div')`
  margin-top: 220px;
  padding: 20px;

  .accordion {
    padding-bottom: 10px;
  }
  button {
    padding: 0 1rem;
    border-width: 1px 0 0 0;
  }

  ${theme.below.lg} {
    margin-top: 64px;
  }
`;

const ButtonContainer = styled('div')`
  padding: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  button {
    width: 100%;
    border-radius: 20px;
    height: 36px;
    border: none;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.6px;
  }

  .apply-button {
    background-color: #911827;
    color: #fff;
  }

  .clear-button {
    background-color: #f5f5f5;
    color: #911827;
  }
`;

const boolFilters = css`
  padding: 1rem;
  label {
    margin-top: 0.5em;
  }
`;

const FilterDrawer = ({
  filters,
  sortOrders,
  close,
  totalProducts,
  ...props
}) => {
  const { clearAllFilters } = useFilters();
  const isActiveListFilter = filters.some((listFilter) => {
    return listFilter.hasActiveItems;
  });

  const listFilters = (filters || []).filter(
    (filter) => filter.__typename === 'ListFilter'
  );

  const rangeFilters = (filters || []).filter(
    (filter) => filter.__typename === 'NumericRangeFilter'
  );

  const isFilters = !!filters;
  const isSortOrders = sortOrders.length > 0;

  return (
    <section {...props}>
      {(isFilters || isSortOrders) && (
        <>
          <Wrapper>
            <Accordion
              single
              initialOpenIndexes={[listFilters.length + rangeFilters.length]}
            >
              {(accordionProps) => (
                <>
                  {isSortOrders && (
                    <SortOrderAccordion
                      sortOrders={sortOrders}
                      accordionProps={accordionProps}
                      startingIdx={listFilters.length + rangeFilters.length}
                    />
                  )}
                  {isFilters && (
                    <>
                      <ListAccordion
                        filters={filters}
                        accordionProps={accordionProps}
                      />
                      <RangeAccordion
                        filters={filters}
                        accordionProps={accordionProps}
                        startingIdx={listFilters.length}
                      />
                    </>
                  )}
                  {isFilters && (
                    <div className={boolFilters}>
                      <BooleanFilters filters={filters} />
                    </div>
                  )}
                </>
              )}
            </Accordion>
          </Wrapper>

          <ButtonContainer>
            {isActiveListFilter && (
              <button className="apply-button" type="button" onClick={close}>
                Visa resultat ({totalProducts} produkter)
              </button>
            )}
            {isActiveListFilter && (
              <button
                className="clear-button"
                type="button"
                onClick={clearAllFilters}
              >
                {t('Clear all filters')}
              </button>
            )}
          </ButtonContainer>
        </>
      )}
    </section>
  );
};
export default FilterDrawer;
